import { get } from 'lodash';

import { isEmpty, isOk } from '@/common/utils';

import { graphqlRequest } from '../urql';
import { getClipArts, getClipartCategories, searchClipArt } from './queries';
import { PER_PAGE_10 } from '@/common/constants';

/**
 * To get list clipart by id of caregory
 * @param {String} id id of category
 * @returns array of object containing list clipart
 */
export const loadClipArtsApi = async (categoryId, page, hideSpiner) => {
  const res = await graphqlRequest(
    getClipArts,
    { categoryId, page, perPages: PER_PAGE_10 },
    hideSpiner
  );

  const cliparts = res.data.cliparts;
  return cliparts.map(c => ({ ...c, imageUrl: c.large_url }));
};

/**
 * To get list caregory of clipart
 * @returns array of object containing list categories
 */
export const loadClipArtCategoriesApi = async (page, hideSpiner) => {
  const res = await graphqlRequest(
    getClipartCategories,
    { page, perPages: PER_PAGE_10 },
    hideSpiner
  );

  return isOk(res) ? res.data.categories : [];
};

/**
 * To get list clipart by keyword
 * @param {String} keyword keyword to search
 * @returns array of object containing list clipart
 */
export const searchClipArtApi = async keyword => {
  if (isEmpty(keyword)) return [];

  const res = await graphqlRequest(searchClipArt, { keyword });

  const cliparts = get(res.data, 'category_keyword.cliparts', []).map(c => ({
    ...c,
    imageUrl: c.large_url
  }));

  return isOk(res) ? cliparts : [];
};
